<div class="spinner-container center h-full">
  <div class="overlay"></div>
  <mat-spinner
    mode="indeterminate"
    diameter="80"
    color="#3270AA"
  ></mat-spinner>
</div>
